export function CloudOfflineFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7.5 20c.169 0 .335-.008.5-.022V20h9v-.027a4.5 4.5 0 10.914-8.954 6 6 0 10-11.86-1.827A5.5 5.5 0 007.5 20zm.793-10.707a1 1 0 011.414 0L12 11.586l2.293-2.293a1 1 0 111.414 1.414L13.414 13l2.293 2.293a1 1 0 01-1.414 1.414L12 14.414l-2.293 2.293a1 1 0 01-1.414-1.414L10.586 13l-2.293-2.293a1 1 0 010-1.414z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
